import { render, staticRenderFns } from "./CardSchedule.vue?vue&type=template&id=dd255d28&scoped=true&"
import script from "./CardSchedule.vue?vue&type=script&lang=js&"
export * from "./CardSchedule.vue?vue&type=script&lang=js&"
import style0 from "./CardSchedule.vue?vue&type=style&index=0&id=dd255d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd255d28",
  null
  
)

export default component.exports